module.exports = __webpack_public_path__ + "img/small-6.5e8a8b83.webp";